import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { clamp } from '../helpers';
import { Dot as StyledDot, Dots as StyledDots } from './Dots.css';

export default function Dots({ activeDotColor, centerDots, currentSlide, dotColor, totalSlides, onClick, zooming }) {
  const centerOffset = useRef(0);
  const slideOffset = useRef(0);

  const currentCenterOffset = currentSlide - slideOffset.current;

  if (currentCenterOffset >= 0 && currentCenterOffset < centerDots) {
    centerOffset.current = currentCenterOffset;
  } else {
    slideOffset.current = currentSlide - centerOffset.current;
  }

  return (
    <StyledDots>
      {[...Array(totalSlides)].map((_, idx) => {
        const centerPage = parseInt(centerDots / 2, 10) + slideOffset.current;
        const distance = Math.abs(idx - centerPage);

        const scaledDistance = clamp(distance - parseInt(centerDots / 2, 10), 0, 3);

        return (
          <StyledDot
            dotColor={dotColor}
            activeDotColor={activeDotColor}
            active={idx === currentSlide}
            distance={scaledDistance}
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            onClick={(event) => onClick(idx, event)}
            zooming={zooming}
          />
        );
      })}
    </StyledDots>
  );
}

Dots.propTypes = {
  activeDotColor: PropTypes.string,
  centerDots: PropTypes.number,
  currentSlide: PropTypes.number.isRequired,
  dotColor: PropTypes.string,
  totalSlides: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  zooming: PropTypes.bool,
};

Dots.defaultProps = {
  activeDotColor: '#4e99e9',
  centerDots: 3,
  dotColor: '#dadbdc',
  zooming: false,
};
